import React from 'react';
import styled from 'styled-components';
import { palette, brand } from 'theme';
import Identicon from 'react-identicons';
import SVG from 'react-inlinesvg';
import IdenticonPlaceholderSVG from 'assets/images/identicon-placeholder.svg';
import IdenticonBgSVG from 'assets/images/identicon-bg.svg';

const IdenticonPlaceholder = styled.img``;

const IdenticonWrapper = styled.div`
  width: ${props => props.size || '100'}px;
  height: ${props => props.size || '100'}px;
  padding: 4px;
  background: linear-gradient(${brand.main.gradient.primary});
  border-radius: 50%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  &:after {
    content: '';
    display: block;
    background: ${palette.grey[800]};
    position: absolute;
    left: 4px;
    right: 4px;
    bottom: 4px;
    top: 4px;
    border-radius: 50%;
    z-index: 0;
  }

  canvas,
  ${IdenticonPlaceholder} {
    max-width: 45%;
    max-height: 45%;
    position: relative;
    z-index: 1;
    top: -10%;
  }
`;

const IdenticonBg = styled(SVG)`
  position: absolute;
  max-width: 36%;
  top: 52%;
  z-index: 1;

  svg {
    max-width: 100%;
    height: auto;
    fill: ${props => props.fillColor};
  }
`;

class UserIdenticon extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { color: '#20D340' };
  }

  render() {
    return (
      <IdenticonWrapper size={this.props.size}>
        {this.props.string ? (
          <Identicon
            {...this.props}
            bg={palette.grey[800]}
            palette={['#20D340', '#18D36B', '#10D297', '#08D2C2', '#00D1ED']}
            padding={30}
            count={4}
            getColor={color => this.setState({ color: color })}
          />
        ) : (
          <IdenticonPlaceholder
            src={IdenticonPlaceholderSVG}
            alt="Identicon Placeholder"
          />
        )}
        <IdenticonBg
          src={IdenticonBgSVG}
          alt="Identicon Background"
          fillColor={this.props.string ? this.state.color : '#20D340'}
        />
      </IdenticonWrapper>
    );
  }
}

export default UserIdenticon;
